import { render, staticRenderFns } from "./EditarSorteio.vue?vue&type=template&id=3c516b1c&"
import script from "./EditarSorteio.vue?vue&type=script&lang=js&"
export * from "./EditarSorteio.vue?vue&type=script&lang=js&"
import style0 from "./EditarSorteio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports